"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastChatsProvider = void 0;
const BroadcastChatsContext_1 = require("./BroadcastChatsContext");
const ChatsProvider_1 = require("./ChatsProvider");
exports.BroadcastChatsProvider = (0, ChatsProvider_1.createChatProvider)(BroadcastChatsContext_1.BroadcastChatsContext, {
    getChatManager: selectedOrgUser => selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getBroadcastChatManager(),
});
